import React, { useState, useCallback, useEffect } from 'react';
import { BREAKPOINTS } from '../../../constants/breakpoints';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useAppDispatch } from '../../hooks/redux';
import { fetchAgentsThunk } from '../../../store/slices/agentSlice';
import { useAgentFromUrl } from '../../hooks/useAgentFromUrl';
import { AgentSidebar } from '../AgentSidebar';
import { ChatArea } from '../../../containers/ChatArea';
import {
  AppLayout as AppLayout__Root,
  AppLayout__Sidebar,
  AppLayout__Main,
  AppLayout__Backdrop,
} from './AppLayout.styles';

export const AppLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MOBILE})`);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    dispatch(fetchAgentsThunk());
  }, [dispatch]);

  // Auto-select agent from ?agent= query parameter (deep-linking)
  useAgentFromUrl();

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const toggleCollapse = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  return (
    <AppLayout__Root>
      <AppLayout__Sidebar
        $open={!isMobile || sidebarOpen}
        $collapsed={!isMobile && sidebarCollapsed}
      >
        <AgentSidebar
          collapsed={!isMobile && sidebarCollapsed}
          onToggleCollapse={!isMobile ? toggleCollapse : undefined}
          onAgentSelect={isMobile ? closeSidebar : undefined}
        />
      </AppLayout__Sidebar>

      <AppLayout__Main>
        <ChatArea onToggleSidebar={isMobile ? toggleSidebar : undefined} />
      </AppLayout__Main>

      <AppLayout__Backdrop $visible={sidebarOpen} onClick={closeSidebar} />
    </AppLayout__Root>
  );
};
